<template>
    <article class="news-card"
             itemscope
             itemtype="https://schema.org/NewsArticle"
    >
        <a :href="card.detailPageUrl" class="news-card__inner">
            <div v-if="card.image.link" class="news-card__image">
                <img :src="card.image.link" :alt="card.name" itemprop="image">
            </div>
            <div class="news-card__content">
                <z-date
                    :date="card.activeFrom"
                    :from="card.activeFrom"
                    size="l"
                    class="u-top-margin--xs u-bottom-margin--2xs"
                    itemprop="datePublished" :datetime="card.activeFrom"
                ></z-date>
                <h3 class="news-card__title" itemprop="headline">
                    {{ card.name }}
                </h3>
                <p class="news-card__excerpt" v-html="card.previewText" itemprop="articleBody"/>
                <div v-if="card.theme.value" class="news-card__tags">
                    <z-tag
                        class="news-card__tag"
                    >
                        {{ card.theme.value }}
                    </z-tag>
                </div>
            </div>
        </a>
    </article>
</template>
<script setup>
defineProps({
    card: {
        type: Object,
        default: {}
    }
})

</script>

<style lang="scss">
.news-card{
    border-radius: 8px;
    border: 1px solid  #E1E4EB;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.00) 35.99%, rgba(10, 144, 122, 0.10) 100%), #FFF;

    &__inner{
        height: 100%;
        display: flex;
        flex-direction: column;
        text-decoration: unset;
    }

    &__image{
        position: relative;
        height: 250px;
        overflow: hidden;
        border-radius: 8px 8px 0 0;

        & img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: 50% 50%;
        }
    }

    &__content{
        @include padding-level(right, S);
        @include padding-level(bottom, S);
        @include padding-level(left, S);
        flex: 1 1;
        display: flex;
        flex-direction: column;

        & .z-date{
            &__other{
                font-weight: 400;
                text-transform: capitalize;
            }
        }
    }

    &__title{
        @include margin-level(bottom, 2XS);
        @include typo-level(L);
        font-weight: 600;
        line-height: 130%;
        color: #00133a;
    }

    &__excerpt {
        @include margin-level(bottom, 2XS);
        max-height: 104px;
        @include typo-level(M);
        color: var(--color-black-80);
        line-height: 130%;
        letter-spacing: -0.2px;
        overflow: hidden;
        text-overflow: ellipsis;

        @include breakpoint(laptop){
            max-height: 114px;
        }
        @include breakpoint(v-tablet){
            max-height: 104px;
        }
    }
    &__tags{
        margin-top: auto;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }
}
</style>
